/**
 * Conversion-Count - Animates the count of conversions done, starting from a base value and increasing over time.
 * The count starts animating when the element comes into view, with a smooth introduction and then live updates.
 * The count is based on a base total, a reference date, and a daily rate of increase, with some random variation
 * for realism.
 */
$(document).ready(function () {
    // Conversion count animation
    var started = false;
    var el = document.querySelector('#conversion-count p:first-child span:first-child');
    if (!el) return;

    var BASE_TOTAL = 748914969;           // value on base date
    var BASE_DATE = new Date('2026-01-30T00:00:00'); // reference date
    var DAILY_RATE = 65000;

    // Calculate elapsed days (including fractional days)
    var now = new Date();
    var deltaDays = (now - BASE_DATE) / (1000 * 60 * 60 * 24);

    // Updated starting total
    var START_TOTAL = Math.floor(BASE_TOTAL + (DAILY_RATE * deltaDays));
    var INTRO_DURATION = 2000;
    var TICK_MS = 1000;

    var currentValue = START_TOTAL;
    var bank = 0;

    function format(n) {
        return Math.floor(n).toLocaleString();
    }

    function animateIntro(done) {
        var start = performance.now();

        function frame(now) {
            var progress = Math.min((now - start) / INTRO_DURATION, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            el.textContent = format(START_TOTAL * eased);

            if (progress < 1) {
                requestAnimationFrame(frame);
            } else {
                el.textContent = format(START_TOTAL);
                done();
            }
        }

        el.textContent = '0';
        requestAnimationFrame(frame);
    }

    function liveUpdate() {
        var basePerSecond = DAILY_RATE / 86400;

        setInterval(function () {
            // Add the average amount for this second, with some natural variation
            bank += basePerSecond * (0.75 + Math.random() * 0.5);

            var increment = 0;

            // Most of the time, release a small amount
            if (bank >= 1 && Math.random() < 0.7) {
                increment = 1;
            }

            // Sometimes release a medium burst
            if (bank >= 2 && Math.random() < 0.3) {
                increment = 2 + Math.floor(Math.random() * 3); // 2 to 4
            }

            // Rarely release a larger burst
            if (bank >= 6 && Math.random() < 0.12) {
                increment = 5 + Math.floor(Math.random() * 8); // 5 to 12
            }

            increment = Math.min(increment, Math.floor(bank));

            if (increment > 0) {
                bank -= increment;
                currentValue += increment;
                el.textContent = format(currentValue);
            }
        }, TICK_MS);
    }

    function startCounter() {
        if (started) return;
        started = true;

        animateIntro(function () {
            currentValue = START_TOTAL;
            liveUpdate();
        });
    }

    if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) {
                observer.disconnect();
                startCounter();
            }
        });
        observer.observe(el);
    } else {
        function checkVisibility() {
            var rect = el.getBoundingClientRect();
            if (rect.top < window.innerHeight && rect.bottom > 0) {
                window.removeEventListener('scroll', checkVisibility);
                startCounter();
            }
        }

        window.addEventListener('scroll', checkVisibility, {passive: true});
        checkVisibility();
    }
});
